/**
 * 客户端初始化方法
 */
define('util/client-init',[
    'zepto',
    'util/client-requestWalletBackToProductList',
    'util/client-refreshMain',
    'util/client-closeView',
    'util/client-getBackClose',
    'util/client-jumpto',
    'util/client-requestBBS',
    'util/client-newView',
    'lib/url'
], function($,
    clientRequestWalletBackToProductList,
    clientRefreshMain,
    clientCloseView,
    clientGetBackClose,
    clientJumpto,
    clientRequestBBS,
    clientNewView,
    toolUrl) {
    // 读取data-client配置
    var getDataClient = function() {
        $(document).on('click', '[data-client]', function(event){
            var $this = $(this);
            var clientFuns = $this.data('client').toString().split(',');
            $.each(clientFuns, function(index, value) {
                if (value === 'wallet') {
                  clientRequestWalletBackToProductList();
                } else if (value === 'refresh') {
                    clientRefreshMain();
                } else if (value === 'close') {
                    if (CLIENT_DATA.client === 'ssj') {
                        var href = $this.attr('href');
                        if (!href || href === '#' || /^javascript:/i.test(href)) {
                            clientCloseView();
                        } else {
                            // 如果目标元素同时配置了 href 和 data-client='close'，则往目标链接追加 getBackClose 行为，模拟关闭再跳转的行为
                            $this.attr('href', href + (toolUrl('?', href) ? '&isBackClose=1' : '?isBackClose=1'));
                        }
                    } else if (CLIENT_DATA.client === 'sgj' && navigator.userAgent.toLowerCase().indexOf('suiguanjia') > -1) {
                        // 绑定关闭webview功能
                        clientCloseView();
                    } else {
                        event.preventDefault();
                        if (event.target.href) {
                            window.location.href = event.target.href;
                        } else {
                            clientCloseView();
                        }
                    }
                }
            });
        });
    };
    // 设置返回跳转
    var getBackClose = function() {
        if (CLIENT_DATA.client === 'ssj') {
            clientGetBackClose(toolUrl('?isBackClose'));
        }
    };
    // herf跳转拦截
    var setJumpto = function() {
        if (CLIENT_DATA.client === 'ssj') {
            $(document).on('click', 'a', function(event) {
                var $this = $(this);
                var href = $this.attr('href');
                var target = $this.attr('target');
                // 如果是空链接/javascript:;/#/javascript:void(0)等值，将不执行跳转.
                // 另外，不允许在a标签中直接执行javascript代码
                if(!href || href === '#' || /^javascript:/i.test(href)) {
                    return;
                } else {
                    if(href.indexOf('bbs.feidee.com') !== -1) {
                        event.stopPropagation();
                        event.preventDefault();
                        clientRequestBBS(href);
                    } else {
                        if(CLIENT_DATA.os === 'ios') {
                            if(/^_blank$/i.test(target) || /_ios/ig.test(target)) {
                                clientNewView(href);
                            } else {
                                window.location.href = href;
                            }
                        } else if(CLIENT_DATA.os === 'android') {
                            if(/^_blank$/i.test(target) || /_android/ig.test(target)) {
                                clientNewView(href);
                            } else {
                                window.location.href = href;
                            }
                        } else {
                            window.location.href = href;
                        }
                    }
                }
            });
        } else if (CLIENT_DATA.client === 'sgj') {
            $(document).on('click', 'a', function(event) {
                var href = $(this).attr('href');
                if (href && href.indexOf('email') !== 0 && href.indexOf('tel') !== 0 && href.indexOf('javascript') !== 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    clientJumpto(href);
                } else if (href && href.indexOf('tel') === 0) {
                    // 随管家部分安卓手机不支持拨号，所以暂时屏蔽此功能
                    if(CLIENT_DATA.os === 'ios') {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                }
            });
        }
    };
    return function() {
        getDataClient();
        getBackClose();
        setJumpto();
    };
});

